// Generic card error types that work across all trading card games

export type CardErrorType =
  | 'misprint'
  | 'miscut'
  | 'off_center'
  | 'ink_error'
  | 'crimping'
  | 'double_print'
  | 'blank_back'
  | 'wrong_back'
  | 'holo_bleed'
  | 'factory_error'
  | 'other';

export const ERROR_TYPE_LABELS: Record<CardErrorType, string> = {
  misprint: 'Misprint',
  miscut: 'Miscut',
  off_center: 'Off-Center',
  ink_error: 'Ink Error',
  crimping: 'Crimping',
  double_print: 'Double Print',
  blank_back: 'Blank Back',
  wrong_back: 'Wrong Back',
  holo_bleed: 'Holo Bleed',
  factory_error: 'Factory Error',
  other: 'Other',
};

export const ERROR_TYPE_OPTIONS: { value: CardErrorType; label: string }[] = [
  { value: 'misprint', label: 'Misprint' },
  { value: 'miscut', label: 'Miscut' },
  { value: 'off_center', label: 'Off-Center' },
  { value: 'ink_error', label: 'Ink Error' },
  { value: 'crimping', label: 'Crimping' },
  { value: 'double_print', label: 'Double Print' },
  { value: 'blank_back', label: 'Blank Back' },
  { value: 'wrong_back', label: 'Wrong Back' },
  { value: 'holo_bleed', label: 'Holo Bleed' },
  { value: 'factory_error', label: 'Factory Error' },
  { value: 'other', label: 'Other' },
];
